"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault").default;

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.magicLink = void 0;

var _now = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/date/now"));

const magicLink = client => {
  let token;
  let expireTime = 0;
  return {
    type: 'magicLink',
    client,
    login: async ({
      email,
      showUI
    }) => await client.auth.loginWithMagicLink({
      email,
      showUI
    }),
    logout: async () => {
      await client.user.logout();
    },
    signup: async ({
      email,
      showUI
    }) => await client.auth.loginWithMagicLink({
      email,
      showUI
    }),
    getToken: async () => {
      if (!token || (0, _now.default)() <= expireTime) {
        expireTime = (0, _now.default)() + 600; // now + 10 min

        return token = await client.user.getIdToken();
      } else {
        return token;
      }
    },
    getUserMetadata: async () => (await client.user.isLoggedIn()) ? await client.user.getMetadata() : null
  };
};

exports.magicLink = magicLink;